// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wIjo","largestCol":"styles_largestCol__2X9G5","smallestCol":"styles_smallestCol__2r7gB"};